var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
var StandardGroupComponent = /** @class */ (function () {
    function StandardGroupComponent() {
        this.targetId = '';
        this.title = '';
        this.items = [];
        this.dismissStandard = new EventEmitter();
        this.isChevronVisible = false;
        this.viewModel = {
            targetIdSelector: '',
            containerId: '',
            containerIdSelector: '',
            dismissText: 'Delete item'
        };
    }
    StandardGroupComponent.prototype.ngOnInit = function () {
        this.viewModel.targetIdSelector = "#" + this.targetId;
        this.viewModel.containerId = this.targetId + "Container";
        this.viewModel.containerIdSelector = "#" + this.targetId + "Container";
    };
    StandardGroupComponent.prototype.toggleVisibility = function () {
        this.isChevronVisible = !this.isChevronVisible;
    };
    StandardGroupComponent.prototype.onDismissClick = function (standard) {
        this.dismissStandard.emit(standard);
        if (this.items.length === 0)
            this.isChevronVisible = false;
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StandardGroupComponent.prototype, "targetId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StandardGroupComponent.prototype, "title", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], StandardGroupComponent.prototype, "items", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], StandardGroupComponent.prototype, "dismissStandard", void 0);
    StandardGroupComponent = __decorate([
        Component({
            selector: 'standard-group',
            template: require('./standard-group.component.html'),
            styles: [require('./standard-group.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], StandardGroupComponent);
    return StandardGroupComponent;
}());
export { StandardGroupComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbmRhcmQtZ3JvdXAuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3RhbmRhcmQtZ3JvdXAuY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFVLE1BQU0sRUFBRSxZQUFZLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFVL0U7SUFTSTtRQVJnQixhQUFRLEdBQVcsRUFBRSxDQUFDO1FBQ3RCLFVBQUssR0FBVyxFQUFFLENBQUM7UUFDbkIsVUFBSyxHQUF1QixFQUFFLENBQUM7UUFDOUIsb0JBQWUsR0FBbUMsSUFBSSxZQUFZLEVBQW9CLENBQUM7UUFHakcscUJBQWdCLEdBQVksS0FBSyxDQUFDO1FBR3JDLElBQUksQ0FBQyxTQUFTLEdBQUc7WUFDYixnQkFBZ0IsRUFBRSxFQUFFO1lBQ3BCLFdBQVcsRUFBRSxFQUFFO1lBQ2YsbUJBQW1CLEVBQUUsRUFBRTtZQUN2QixXQUFXLEVBQUUsYUFBYTtTQUM3QixDQUFDO0lBQ04sQ0FBQztJQUNNLHlDQUFRLEdBQWY7UUFDSSxJQUFJLENBQUMsU0FBUyxDQUFDLGdCQUFnQixHQUFHLE1BQUksSUFBSSxDQUFDLFFBQVUsQ0FBQztRQUN0RCxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsR0FBTSxJQUFJLENBQUMsUUFBUSxjQUFXLENBQUM7UUFDekQsSUFBSSxDQUFDLFNBQVMsQ0FBQyxtQkFBbUIsR0FBRyxNQUFJLElBQUksQ0FBQyxRQUFRLGNBQVcsQ0FBQztJQUN0RSxDQUFDO0lBQ00saURBQWdCLEdBQXZCO1FBQ0ksSUFBSSxDQUFDLGdCQUFnQixHQUFHLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDO0lBQ25ELENBQUM7SUFDTSwrQ0FBYyxHQUFyQixVQUFzQixRQUEwQjtRQUM1QyxJQUFJLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNwQyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxLQUFLLENBQUM7WUFDdkIsSUFBSSxDQUFDLGdCQUFnQixHQUFHLEtBQUssQ0FBQztJQUN0QyxDQUFDO0lBNUJRO1FBQVIsS0FBSyxFQUFFOzs0REFBOEI7SUFDN0I7UUFBUixLQUFLLEVBQUU7O3lEQUEyQjtJQUMxQjtRQUFSLEtBQUssRUFBRTs7eURBQXVDO0lBQ3JDO1FBQVQsTUFBTSxFQUFFO2tDQUF5QixZQUFZO21FQUEwRDtJQUovRixzQkFBc0I7UUFMbEMsU0FBUyxDQUFDO1lBQ1AsUUFBUSxFQUFFLGdCQUFnQjtZQUMxQixRQUFRLEVBQUUsT0FBTyxDQUFDLGlDQUFpQyxDQUFDO1lBQ3BELE1BQU0sRUFBRSxDQUFDLE9BQU8sQ0FBQyxpQ0FBaUMsQ0FBQyxDQUFDO1NBQ3ZELENBQUM7O09BQ1csc0JBQXNCLENBOEJsQztJQUFELDZCQUFDO0NBQUEsQUE5QkQsSUE4QkM7U0E5Qlksc0JBQXNCIn0=